module.exports = __webpack_public_path__ + "img/15.0f9043fe.webp";